import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import SimilarCardAlpha from "./SimilarCardAlpha";

function SimilarWorkshopArea({ ctype, srcid, artforms }) {
  /* ------------------------------------------------------------------ */
  /* 1.  Build the URL from props                                       */
  /* ------------------------------------------------------------------ */
  const API_URL = `https://test.campfr.com/api/list_similar_workshops/${ctype}/${srcid}/${artforms}`;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;

  /* ------------------------------------------------------------------ */
  /* 2.  Local state                                                    */
  /* ------------------------------------------------------------------ */
  const [similars, setSimilars] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  /* ------------------------------------------------------------------ */
  /* 3.  Fetch once (or whenever URL / token change)                    */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    let isMounted = true;                 // guard against race on unmount
    (async () => {
      try {
        const { data } = await axios.get(API_URL, {
          headers: { "X-API-TOKEN": API_TOKEN },
        });
        if (!isMounted) return;

        const workshopsArr =
  Array.isArray(data) ? data :
  data && typeof data === "object" ? Object.values(data) : [];

        setSimilars(workshopsArr);
      } catch (err) {
        if (isMounted) setError(err.message || "Failed to fetch API");
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => { isMounted = false; };  // clean‑up
  }, [API_URL, API_TOKEN]);

  /* ------------------------------------------------------------------ */
  /* 4.  Only build the cards once data is here                         */
  /* ------------------------------------------------------------------ */
  const similarCards = useMemo(
    () =>
      similars.map((similar) => {
        let workshop_image = `${similar.id}${similar.ctype === "online" ? "_online" : ""}.jpg`;

        return (
          <div key={similar.id} className="col-12" style={{ marginBottom: 20 }}>
            <SimilarCardAlpha
              image={workshop_image}
              title={similar.title_with}
              tutors={similar.tutor_string}
              short_url={similar.short_url}
              ctype={similar.ctype}
            />
          </div>
        );
      }),
    [similars]
  );

  /* ------------------------------------------------------------------ */
  /* 5.  Render                                                         */
  /* ------------------------------------------------------------------ */
  if (loading) return <p>Loading similar workshops…</p>;
  if (error)   return <p className="text-danger">Error: {error}</p>;

  return (
    <div className="guide-area guide-style-one">
      <div className="container">
        <div className="row">{similarCards}</div>
      </div>
    </div>
  );
}

export default SimilarWorkshopArea;
